import { Injectable, TemplateRef } from '@angular/core'
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { ComponentType } from '@angular/cdk/portal'
import * as R from 'ramda'
import { take } from 'rxjs/operators'
import { SharedModule } from '@tv3/shared/shared.module'

@Injectable({
  providedIn: SharedModule,
})
export class SidePanelService {
  constructor(private dialog: MatDialog) {}

  public openSide<T, D = any>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<D>
  ): MatDialogRef<T> {
    const defaultConfig: MatDialogConfig<D> = {
      width: '100%',
      height: '100%',
      maxWidth: 'auto',
      backdropClass: '',
      position: {
        right: '0px',
        bottom: '0px',
      },
      panelClass: ['modal', 'side-modal-lg', 'modal-edit-expense', 'right'],
    }

    const dialogRef = this.dialog.open(componentOrTemplateRef, R.merge(defaultConfig, config))

    if (dialogRef['_overlayRef'].overlayElement) {
      dialogRef['_overlayRef'].overlayElement.parentElement.className += ' dialog-wrapper'
    }

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef['_containerInstance']['_elementRef'].nativeElement.classList.add('side-closing')
      })

    return dialogRef
  }
}
